import type { ReactNode } from 'react';

import {
  Button,
  Popover,
  PopoverContent,
  PopoverTrigger,
  useDisclosure,
} from '@frontend/legacy-components';

import { OnClosePopoverContext } from './context';

export type FiltersProps = {
  content: ReactNode;
};

export const Filters = ({ content }: FiltersProps) => {
  const { isOpen, onClose, onOpen, onToggle } = useDisclosure();

  return (
    <Popover
      isOpen={isOpen}
      onClose={onClose}
      onOpen={onOpen}
      placement="bottom-start"
      returnFocusOnClose={false}
    >
      <PopoverTrigger>
        <Button variant="secondary" onClick={onToggle}>
          Filters
        </Button>
      </PopoverTrigger>
      <PopoverContent>
        <OnClosePopoverContext.Provider value={onClose}>
          {content}
        </OnClosePopoverContext.Provider>
      </PopoverContent>
    </Popover>
  );
};
